export default "__VITE_ASSET__bf52a9c9__"